<template>
    <div class="avatar column justify-center"><slot></slot></div>
</template>

<script>
export default {
    name: 'Avatar'
}
</script>

<style lang="scss">
 @use "@/assets/scss/vars.scss" as *;
    .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        line-height: 40px;
        color: white;
        text-align: center;
        font-size: 17px;
        font-weight: bold;
        background: $supporter-1;
        box-shadow: $shadow;
        border: 1.9px solid white;
        & img{
            width: 100%;
            border-radius: 60%;
        }
    }
</style>
